import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { timer, Subscription } from 'rxjs';

interface InactivityModalData {
  countdownSeconds?: number;
  expiresAtMs?: number;
}

@Component({
  selector: 'app-inactivity-modal',
  template: `
    <div class="p-4 text-center">
      <h2 mat-dialog-title class="text-xl font-bold mb-4">Session Inactivity</h2>
      <mat-dialog-content>
        <p class="mb-4">Your session is about to expire due to inactivity.</p>
        <div class="text-3xl font-mono font-bold text-primary mb-4">
          {{ countdown }}s
        </div>
        <p>Do you want to stay logged in?</p>
      </mat-dialog-content>
      <mat-dialog-actions align="center" class="mt-6 flex justify-center gap-4">
        <button mat-stroked-button color="warn" (click)="winstonLogout()">
          Logout
        </button>
        <button mat-raised-button color="primary" (click)="stayLoggedIn()">
          Stay Logged In
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    :host { display: block; min-width: 300px; }
    .text-primary { color: #3f51b5; }
  `]
})
export class InactivityModalComponent implements OnInit, OnDestroy {
  private readonly dialogRef = inject(MatDialogRef<InactivityModalComponent>);
  private readonly data = inject<InactivityModalData>(MAT_DIALOG_DATA, {
    optional: true,
  });
  private readonly expiresAtMs = this.data?.expiresAtMs;
  countdown = this.getRemainingSeconds();
  private timerSub?: Subscription;

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    this.timerSub?.unsubscribe();
  }

  private startCountdown() {
    this.timerSub = timer(1000, 1000).subscribe({
      next: () => {
        this.countdown = this.getRemainingSeconds();
        if (this.countdown <= 0) {
          this.dialogRef.close('logout');
        }
      },
    });
  }

  private getRemainingSeconds(): number {
    if (typeof this.expiresAtMs === 'number') {
      return Math.max(0, Math.ceil((this.expiresAtMs - Date.now()) / 1000));
    }

    return this.data?.countdownSeconds ?? 60;
  }

  stayLoggedIn() {
    this.dialogRef.close('refresh');
  }

  winstonLogout() {
    this.dialogRef.close('logout');
  }
}
